export const LEGAL_DOCUMENT_VERSION = 'barometro-legal-2026-05-05';
export const LEGAL_TERMS_VERSION = LEGAL_DOCUMENT_VERSION;
export const LEGAL_PRIVACY_VERSION = LEGAL_DOCUMENT_VERSION;
export const LEGAL_UPDATED_AT = '5 de mayo de 2026';
export const LEGAL_CONTACT_EMAIL = process.env.REACT_APP_LEGAL_CONTACT_EMAIL || 'eventos@lytiks.solutions';

export const LEGAL_SOURCES = [
  {
    label: 'Ley Orgánica de Protección de Datos Personales',
    url: 'https://www.registroficial.gob.ec/267223-2/',
  },
  {
    label: 'Reglamento General de la Ley Orgánica de Protección de Datos Personales',
    url: 'https://gobec-dev02.gobiernoelectronico.gob.ec/regulaciones/reglamento-general-ley-organica-proteccion-datos-personales-0',
  },
];

export const LEGAL_DOCUMENTS = {
  terms: {
    id: 'terms',
    shortTitle: 'Términos de uso',
    title: 'Términos y Condiciones de Uso',
    version: LEGAL_TERMS_VERSION,
    updatedAt: LEGAL_UPDATED_AT,
    intro:
      'Estos términos regulan el acceso y uso de la plataforma Barómetro Naviero Ecuador. El uso de la plataforma implica actuar conforme a estos términos, la legislación ecuatoriana aplicable y las reglas operativas comunicadas por el administrador.',
    sections: [
      {
        title: 'Aceptación y carácter vinculante',
        body: [
          'El acceso autenticado requiere la aceptación expresa, libre, informada e inequívoca de estos Términos y Condiciones y de la Política de Privacidad vigente.',
          'Si el usuario no acepta estos documentos, no deberá utilizar las funcionalidades privadas de la plataforma.',
        ],
      },
      {
        title: 'Capacidad legal y representación',
        body: [
          'La plataforma está dirigida a personas con capacidad legal para obligarse y a representantes o colaboradores autorizados de empresas participantes.',
          'Quien accede en nombre de una empresa declara contar con autorización suficiente para registrar información, corregir formularios y recibir comunicaciones relacionadas con el levantamiento.',
        ],
      },
      {
        title: 'Naturaleza del servicio',
        body: [
          'La plataforma permite levantar información declarativa sobre percepción del servicio naviero, gestionar revisiones administrativas, generar indicadores agregados y publicar reportes del Barómetro Naviero Ecuador.',
          'Los resultados, dashboards, narrativas ejecutivas e indicadores son referenciales. No sustituyen asesoría legal, financiera, logística, comercial ni profesional.',
        ],
      },
      {
        title: 'Registro, credenciales y seguridad',
        body: [
          'Cada usuario es responsable de mantener la confidencialidad de sus credenciales y de las acciones realizadas desde su cuenta.',
          'Está prohibido compartir accesos, intentar eludir controles de seguridad, suplantar usuarios o extraer información fuera de los mecanismos permitidos por la plataforma.',
        ],
      },
      {
        title: 'Uso permitido de la plataforma',
        body: [
          'El usuario se compromete a entregar información veraz, pertinente y actualizada, y a corregir los envíos cuando el administrador solicite revisión.',
          'No se permite realizar ingeniería inversa, scraping, extracción masiva, explotación de vulnerabilidades, carga de contenido malicioso ni usos que afecten la disponibilidad o integridad del sistema.',
        ],
      },
      {
        title: 'Confidencialidad y uso de resultados',
        body: [
          'La información individual de empresas participantes se trata como confidencial y se usa principalmente para validación, análisis agregado y generación de indicadores.',
          'Los resultados públicos deben interpretarse como información agregada del levantamiento y no como una medición total del mercado ni como calificación definitiva de actores específicos.',
        ],
      },
      {
        title: 'Propiedad intelectual',
        body: [
          'Los contenidos, metodologías, interfaces, reportes, modelos, indicadores y desarrollos de la plataforma pertenecen a sus respectivos titulares u operadores autorizados.',
          'El usuario no adquiere derechos de propiedad intelectual por acceder a la plataforma o descargar reportes.',
        ],
      },
      {
        title: 'Automatización e inteligencia artificial',
        body: [
          'La plataforma puede usar herramientas analíticas y servicios de inteligencia artificial para apoyar la generación de narrativas ejecutivas, siempre a partir de datos agregados o necesarios para el reporte.',
          'La narrativa asistida por IA es un insumo de análisis y debe ser revisada por el administrador antes de su uso externo o publicación.',
        ],
      },
      {
        title: 'Disponibilidad, cambios y suspensión',
        body: [
          'El servicio puede modificarse, suspenderse o actualizarse por razones operativas, técnicas, de seguridad, regulatorias o de mejora.',
          'El administrador podrá suspender o terminar accesos cuando exista incumplimiento de estos términos, uso indebido, riesgo de seguridad o requerimiento legal.',
        ],
      },
      {
        title: 'Protección de datos personales',
        body: [
          'El tratamiento de datos personales se rige por la normativa ecuatoriana aplicable y por la Política de Privacidad vigente de la plataforma.',
          'La aceptación de estos términos no limita los derechos que correspondan a los titulares de datos personales conforme a la Ley Orgánica de Protección de Datos Personales.',
        ],
      },
      {
        title: 'Jurisdicción',
        body: [
          'Estos términos se rigen por la legislación de la República del Ecuador. Cualquier controversia se someterá a los mecanismos y autoridades competentes conforme a la normativa aplicable.',
        ],
      },
    ],
  },
  privacy: {
    id: 'privacy',
    shortTitle: 'Política de privacidad',
    title: 'Política de Privacidad y Protección de Datos Personales',
    version: LEGAL_PRIVACY_VERSION,
    updatedAt: LEGAL_UPDATED_AT,
    intro:
      'Esta política informa cómo se tratan los datos personales y empresariales dentro de la plataforma Barómetro Naviero Ecuador, en línea con la Ley Orgánica de Protección de Datos Personales y su Reglamento General.',
    sections: [
      {
        title: 'Responsable y canal de contacto',
        body: [
          'El responsable del tratamiento es FEDEXPOR, respecto de los datos tratados para el levantamiento, análisis y reporte del Barómetro Naviero Ecuador.',
          `Para solicitudes operativas relacionadas con esta plataforma se puede contactar al administrador o escribir a ${LEGAL_CONTACT_EMAIL}. Si FEDEXPOR designa un canal formal distinto, ese canal prevalecerá para el ejercicio de derechos.`,
        ],
      },
      {
        title: 'Datos tratados',
        body: [
          'La plataforma puede tratar datos identificativos y de contacto, datos de autenticación, datos empresariales, información declarativa del cuestionario, observaciones de revisión, archivos o evidencias cargadas, fechas de envío, historial de revisión y registros técnicos básicos de uso.',
          'No se solicita información de menores de edad ni categorías especiales de datos personales. El usuario debe evitar cargar datos sensibles o información no necesaria para el levantamiento.',
        ],
      },
      {
        title: 'Finalidades',
        body: [
          'Los datos se usan para administrar usuarios, habilitar el acceso a la plataforma, recibir cuestionarios, revisar y aprobar envíos, solicitar correcciones, enviar notificaciones transaccionales, construir indicadores agregados, generar reportes y mejorar la operación del servicio.',
          'También pueden usarse para trazabilidad, seguridad, auditoría, soporte técnico, cumplimiento de obligaciones legales y atención de solicitudes de titulares.',
        ],
      },
      {
        title: 'Base de licitud',
        body: [
          'El tratamiento se apoya en el consentimiento del titular, la ejecución de la relación operativa con usuarios y empresas participantes, el interés legítimo en administrar el levantamiento y la atención de obligaciones legales aplicables.',
          'Cuando el tratamiento dependa del consentimiento, el titular puede revocarlo conforme a la normativa aplicable. La revocatoria podría limitar el acceso o impedir la continuidad de ciertas funcionalidades privadas.',
        ],
      },
      {
        title: 'Información agregada y anonimización',
        body: [
          'La plataforma puede agregar, disociar o anonimizar información para reducir el riesgo de identificación individual y publicar resultados estadísticos del Barómetro Naviero Ecuador.',
          'Los reportes públicos deben evitar exponer información individual de una empresa participante salvo que exista autorización, base legal suficiente o necesidad operativa expresamente validada.',
        ],
      },
      {
        title: 'Proveedores y transferencias',
        body: [
          'Para operar el servicio pueden intervenir proveedores tecnológicos, incluyendo infraestructura de Firebase/Google Cloud, servicios de correo transaccional como SendGrid/Twilio, servicios de analítica o inteligencia artificial y proveedores de desarrollo o soporte como Lytiks.',
          'Estos proveedores deben tratar la información bajo estándares de seguridad, confidencialidad y finalidad. Cuando existan transferencias internacionales, deberán aplicarse garantías compatibles con la normativa ecuatoriana.',
        ],
      },
      {
        title: 'Conservación',
        body: [
          'Los datos se conservarán durante el tiempo necesario para cumplir las finalidades del levantamiento, mantener trazabilidad histórica, atender auditorías, resolver solicitudes y cumplir obligaciones legales.',
          'Cuando la información deje de ser necesaria, podrá eliminarse, anonimizarse o conservarse de forma agregada según corresponda.',
        ],
      },
      {
        title: 'Seguridad',
        body: [
          'Se aplican medidas técnicas y organizativas razonables para proteger confidencialidad, integridad y disponibilidad de la información, incluyendo autenticación, reglas de acceso, controles de Firestore, segregación por rol y uso de infraestructura administrada.',
          'Ningún sistema es absolutamente infalible. Los usuarios deben proteger sus credenciales, cerrar sesión en equipos compartidos y reportar incidentes o accesos no autorizados.',
        ],
      },
      {
        title: 'Derechos de los titulares',
        body: [
          'Los titulares pueden solicitar información sobre el tratamiento de sus datos y ejercer los derechos reconocidos por la normativa ecuatoriana, incluyendo acceso, eliminación, rectificación, actualización, oposición, anulación, limitación, portabilidad y revisión de decisiones automatizadas cuando corresponda.',
          `Las solicitudes pueden canalizarse por medio del administrador de la plataforma o al correo operativo ${LEGAL_CONTACT_EMAIL}, sin perjuicio del canal formal que FEDEXPOR comunique para protección de datos personales.`,
        ],
      },
      {
        title: 'Cookies, registros técnicos y comunicaciones',
        body: [
          'La plataforma puede generar registros técnicos necesarios para seguridad, autenticación, funcionamiento, diagnóstico y mejora del servicio.',
          'Las comunicaciones transaccionales relacionadas con recepción, aprobación o solicitud de revisión de formularios forman parte de la operación del levantamiento.',
        ],
      },
      {
        title: 'Cambios de esta política',
        body: [
          'La política puede actualizarse por cambios regulatorios, técnicos u operativos. Cuando existan cambios relevantes, la plataforma podrá solicitar una nueva aceptación antes de permitir el uso autenticado.',
        ],
      },
    ],
  },
};

export const LEGAL_ACCEPTANCE_SUMMARY = [
  'He leído y acepto los Términos y Condiciones de Uso vigentes.',
  'Autorizo el tratamiento de mis datos personales conforme a la Política de Privacidad vigente.',
  'Declaro que cuento con autorización para usar la plataforma en nombre de la empresa participante, cuando aplique.',
  'Entiendo que mis envíos pueden utilizarse para análisis agregados, reportes, notificaciones transaccionales y mejora del servicio.',
];

export const hasAcceptedCurrentLegal = (user) => (
  user?.legalAcceptance?.version === LEGAL_DOCUMENT_VERSION &&
  user?.legalAcceptance?.termsVersion === LEGAL_TERMS_VERSION &&
  user?.legalAcceptance?.privacyVersion === LEGAL_PRIVACY_VERSION
);
